(() => {
  if (customElements.get('sharki-catalog')) return;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sf-find-club]');
    if (!button || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const catalog = document.querySelector('sharki-catalog');
    const target = catalog?.querySelector('.sf-catalog__heading') || catalog;
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    const header = document.querySelector('.shopify-section-header');
    const offset = (header?.getBoundingClientRect().height || 0) + 20;
    target.style.scrollMarginTop = `${offset}px`;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({behavior: reducedMotion ? 'instant' : 'smooth', block: 'start'});
    if (window.innerWidth >= 990) {
      requestAnimationFrame(() => catalog.querySelector('[data-search]')?.focus({preventScroll: true}));
    }
  }, true);
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  // Cache completed catalogs only. Each instance owns its cancellable request.
  const caches = new Map();
  async function loadCatalog(source, signal) {
    if (caches.has(source)) return caches.get(source);
    let url = new URL(source, location.origin);
    url.searchParams.set('sort_by', 'created-descending');
    const items = new Map(), seen = new Set();
    while (url) {
      signal.throwIfAborted();
      url.searchParams.set('section_id', 'sharki-catalog-data');
      if (url.origin !== location.origin || seen.has(url.href) || seen.size >= 100) throw Error('Invalid pagination');
      seen.add(url.href);
      const response = await fetch(url, {signal, credentials: 'same-origin'});
      if (!response.ok) throw Error('Catalog unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      signal.throwIfAborted();
      const payload = doc.querySelector('[data-sf-catalog-page]');
      if (!payload) throw Error('Missing catalog');
      const data = JSON.parse(payload.textContent);
      if (!Array.isArray(data.items)) throw Error('Invalid catalog');
      for (const item of data.items) items.set(item.id, item);
      url = data.next ? new URL(data.next, location.origin) : null;
    }
    const result = [...items.values()];
    caches.set(source, result);
    return result;
  }
  class SharkiCatalog extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controls = this.querySelector('.sf-controls');
      this.controls.hidden = false;
      this.controls.querySelectorAll('[disabled]').forEach(control => control.disabled = false);
      this.grid = this.querySelector('[data-grid]');
      this.status = this.querySelector('[data-status]');
      this.search = this.querySelector('[data-search]');
      this.activeClub = '';
      this.league = this.querySelector('[data-league]');
      this.sort = this.querySelector('[data-sort]');
      this.more = this.querySelector('[data-more]');
      this.limit = 12;
      const submitSearch = event => {
        event.preventDefault();
        this.update();
        if (window.innerWidth < 990) this.search.blur();
      };
      this.querySelector('[data-search-form]')?.addEventListener('submit', submitSearch);
      this.search.addEventListener('keydown', event => {
        if (event.key === 'Enter' && !event.isComposing) submitSearch(event);
      });
      this.search.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.cancelLoad();
        this.timer = setTimeout(() => this.update(), 250);
      });
      this.controls.addEventListener('change', event => {
        if (event.target !== this.search) this.update();
      });
      this.addEventListener('click', event => {
        const chip = event.target.closest('[data-club]');
        if (chip) {this.activeClub = chip.dataset.club; this.league.value = ''; this.update();}
        if (event.target.closest('[data-reset]')) {this.search.value = ''; this.activeClub = ''; this.league.value = ''; this.sort.value = 'newest'; this.update();}
        if (event.target.closest('[data-retry]')) this.load();
        if (event.target.closest('[data-more]') && this.items) {this.limit += 12; this.render(true);}
      });
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {this.observer.disconnect(); this.load();}
      }, {rootMargin: '200px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {this.observer?.disconnect(); clearTimeout(this.timer); this.cancelLoad();}
    cancelLoad() {
      this.requestId = (this.requestId || 0) + 1;
      this.controller?.abort();
      this.loading = false;
      this.grid.setAttribute('aria-busy', 'false');
    }
    async load() {
      if (this.loading) return;
      const requestId = this.requestId = (this.requestId || 0) + 1;
      const controller = this.controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      this.loading = true;
      this.status.textContent = this.dataset.loading;
      this.grid.setAttribute('aria-busy', 'true');
      this.querySelector('[data-retry]').hidden = true;
      try {
        const items = await loadCatalog(this.dataset.source, controller.signal);
        if (requestId !== this.requestId || !this.isConnected) return;
        this.items = items;
        this.update();
      } catch {
        if (requestId !== this.requestId || !this.isConnected) return;
        this.status.textContent = this.dataset.error;
        this.querySelector('[data-retry]').hidden = false;
      } finally {
        clearTimeout(timeout);
        if (requestId === this.requestId) {
          this.loading = false;
          this.grid.setAttribute('aria-busy', 'false');
        }
      }
    }
    update() {
      clearTimeout(this.timer);
      for (const button of this.querySelectorAll('[data-club]')) button.setAttribute('aria-pressed', String(button.dataset.club === this.activeClub && (this.activeClub !== '' || !this.league.value)));
      this.limit = 12;
      if (this.items) this.render(); else this.load();
    }
    render(focusNew = false) {
      const words = normalize(this.search.value.trim()).split(/\s+/).filter(Boolean).map(word => word === 'psg' ? 'paris' : word === 'om' ? 'marseille' : word);
      const found = this.items.filter(item => {
        const title = normalize(item.title);
        return words.every(word => title.includes(word)) && (!this.activeClub || item.collections.includes(this.activeClub)) && (!this.league.value || item.collections.includes(this.league.value));
      });
      found.sort((a,b) => this.sort.value === 'price-up' ? a.price - b.price || b.created - a.created : this.sort.value === 'price-down' ? b.price - a.price || b.created - a.created : b.created - a.created || b.id - a.id);
      const oldCount = this.grid.children.length;
      const fragment = document.createDocumentFragment();
      for (const item of found.slice(0, this.limit)) {
        const card = document.createElement('a'); card.className = 'sf-product'; card.href = item.url;
        const media = document.createElement('div'); media.className = 'sf-product__media';
        if (item.image) {const img = document.createElement('img'); img.src = item.image; img.srcset = [240,360,540,720].map(width => { const url = new URL(item.image, location.origin); url.searchParams.set('width', width); return url.href + ' ' + width + 'w'; }).join(', '); img.sizes = '(min-width: 990px) 30vw, 46vw'; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = 720; img.height = 900; media.append(img);}
        const isNew = Date.now()/1000 - Number(item.created) < 30*86400;
        if (!item.available || isNew) {const badge = document.createElement('span'); badge.className = 'sf-product__badge'; badge.textContent = item.available ? this.dataset.new : this.dataset.sold; media.append(badge);}
        const title = document.createElement('h3'); title.textContent = item.title;
        const price = document.createElement('p'); price.className = 'sf-product__price'; price.textContent = (item.varies ? this.dataset.from + ' ' : '') + item.money;
        card.append(media,title,price); fragment.append(card);
      }
      this.grid.replaceChildren(fragment);
      this.status.textContent = found.length ? this.dataset.count.replace('[shown]', Math.min(found.length,this.limit)).replace('[total]',found.length) : this.dataset.empty;
      this.more.hidden = found.length <= this.limit;
      if (focusNew) this.grid.children[oldCount]?.focus({preventScroll:true});
    }
  }
  customElements.define('sharki-catalog', SharkiCatalog);
})();
